<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Pedidos</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <NuevaVentaModalComponent />
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refresh</a>
            </div>
            <div class="col-sm-6">
              <form action="#" class="form-inline justify-content-sm-end" @submit="filterDataSubmit">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Busca Numero o Cliente"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit" >
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="col-12">
                </div>
                <br>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActivo"
                  @click="filterData"
                >
                  <option value="">Todos</option>
                  <option value="B">Cerrado</option>
                  <option value="A">Abierto</option>
                  <option value="H">Despachado</option>
                  <option value="9">Anulado</option>
                </select>

              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Tienda</th>
                <th>Caja</th>
                <th>Vendedor</th>
                <th>Cliente</th>
                <th>Estado</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id" @click="rowClick(current)">
                <td class="text-center">{{ current.numero }}</td>
                <td>{{ current.fecha }}</td>
                <td>{{ current.tienda.nombre }}</td>
                <td>{{ current.caja.caja }}</td>
                <td>
                  <UsuarioEnTablaComponent :current="current.vendedor" />
                </td>
                <td v-if="current.cliente">({{ current.cliente.nit }}) {{ current.cliente.nombre }}</td>
                <td class="text-right">
                  <div data-title="Activo" data-toggle="tooltip" v-html="current.estado_str"></div>
                </td>
                <td class="text-right">Q {{ current.total }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import PedidosServices from "@/services/pos/PedidosServices";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import NuevaVentaModalComponent from "@/components/pos/pos_servicios/NuevaVentaModalComponent";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    NuevaVentaModalComponent,
  },
  data() {
    return {
      current: {
        agrupar_por_fardo: false,
      },
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: "",
      data: []
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "pos-venta-ver",
        params: { id: current.id }
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estado: this.filterActivo
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActivo
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActivo
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      PedidosServices.fetch(params).then(res => {
        self.data = res.data;
      });
    },
    showModalEdit() {}
  }
};
</script>
